import { useEffect, useState } from "react";
import moment from "moment";

import toast from "react-hot-toast";
import constants from "../../../../constants";
import { cloneDeep } from "lodash";
import useUploadService from "hooks/useUploadService";
import {
  createLocalDateStringForAPIRequest,
  createLocalDateStringForAPIRequestDueDate,
  decodeId,
  getStorage,
  parseCalendarDateToLocalDate,
} from "utils";
import {
  EditTask,
  addNewTask,
  filterOptionsStaff,
  useAllTasks,
  useMyTaskById,
} from "repositories/task-management-repository";
import useTaskModule from "./useTaskModule";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { useQueryClient } from "react-query";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
const pageSize = 10;
const containerName = "globalnotesattachments";
export const useAddTaskController = ({
  t,
  history,
  addTask,
  assigneeTaskId,
  handleActiontask = () => {},
  editTaskId = undefined,
  isInsideModal = false,
  closeModalHandler,
}) => {
  const allowedTypes = constants.chat.allowedTypesForMessage;
  const { upload: uploadImage } = useUploadService();
  const { getIdToCheckOwnerChange, selectedId, selectedOwnerIdString } =
    useAccountOwnerCommon();
  const location = useLocation();
  const { accountOwnerId } = useTaskModule(useAllTasks);
  const queryClient = useQueryClient();
  const prioritiesOptions = [
    { id: 2, name: "Medium" },
    { id: 1, name: "High" },
    { id: 3, name: "Low" },
  ];
  useEffect(() => {
    if (getIdToCheckOwnerChange()) {
      history.push(constants.routes.taskManagements.taskManagement);
    }
  }, [selectedId]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    startDate: null,
    DueDate: null,
    Assignies: [],
    notifyAssignees: false,
    notifyAssignor: false,
  });
  const [priority, setPriority] = useState(2);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState({});
  const [confirmedStaff, setConfirmedStaff] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    value: "all_offices",
    label: "All Offices",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [OptionsStaff, setOptionsStaff] = useState([]);
  const [staffSelectedCount, setStaffSelectedCounts] = useState(0);
  const { pageNumber } = useState(1);
  const isChatFromDashBoard = getStorage("isChatFromDashBoard");
  let { taskId } = useParams();
  taskId = editTaskId ?? decodeId(taskId);

  const queries = useMyTaskById(taskId, pageSize, pageNumber, {
    enabled: !!taskId && addTask,
  });
  const [taskDetail, assigneeData] = queries.map((query) => query?.data);
  const detailsLoading = queries.some((query) => query?.isLoading);

  const [dates, setdates] = useState({
    startDate: moment().startOf("day").toDate(),
    DueDate: null,
  });

  useEffect(() => {
    if (taskId) {
      setFormData({
        title: taskDetail?.title,
        description: taskDetail?.description,
        startDate: taskDetail?.startDate,
        DueDate: taskDetail?.dueDate,
        Assignies: [],
        notifyAssignees: taskDetail?.notifyAssignees,
        notifyAssignor: taskDetail?.notifyAssignor,
      });
      setPriority(taskDetail?.priority);
      setStaffSelectedCounts(taskDetail?.totalAssignees || 0);
      setFileNames(
        Array.isArray(taskDetail?.taskDocumentUrls)
          ? taskDetail.taskDocumentUrls.map((doc) => ({
              path: doc.filePath,
              file: null,
              Id: doc.id || 0,
              IsDeleted: doc.isDeleted || false,
            }))
          : [],
      );
      setdates({
        startDate:
          parseCalendarDateToLocalDate(taskDetail?.startDate) ||
          moment().startOf("day").toDate(),
        DueDate: parseCalendarDateToLocalDate(taskDetail?.dueDate),
      });
    }
  }, [taskDetail, assigneeData]);

  const handleOnChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const updateDatesValues = (e, type) => {
    const nextDates = {
      ...dates,
      [type]: e,
    };
    setdates(nextDates);

    setErrors((prevErrors) => {
      const nextErrors = { ...prevErrors };
      const hasBothDates = nextDates.startDate && nextDates.DueDate;
      const isDueBeforeStart =
        hasBothDates &&
        moment(nextDates.DueDate)
          .startOf("day")
          .isBefore(moment(nextDates.startDate).startOf("day"));

      if (isDueBeforeStart) {
        nextErrors.DueDate = t("taskManagement.dueDateGreaterThanStartDate");
      } else if (nextDates.DueDate) {
        delete nextErrors.DueDate;
      }

      if (nextDates.startDate && !isDueBeforeStart) {
        delete nextErrors.startDate;
      }

      return nextErrors;
    });
  };

  /** Keep calendar day as selected (no UTC conversion). */
  const formatSelectedDatesForApi = (selectedDates) => ({
    startDate: createLocalDateStringForAPIRequest(selectedDates?.startDate),
    dueDate: createLocalDateStringForAPIRequestDueDate(selectedDates?.DueDate),
  });

  const handleCheckboxChange = (id, event) => {
    const { checked } = event.target;
    setSelectedStaff((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };

  const handleToggle = () => {
    if (isModalOpen) {
      setIsModalOpen(false);
      setSelectedOption({ value: "all_offices", label: "All Offices" });
    } else {
      setIsModalOpen(true);
      getOfficeMembers();
    }
  };

  const handleApplyCheck = (e) => {
    const selected = Object.keys(selectedStaff).filter(
      (key) => selectedStaff[key],
    );
    setConfirmedStaff(selected);
    setStaffSelectedCounts(() => {
      if (taskId) {
        return taskDetail?.totalAssignees + selected?.length;
      } else {
        return selected?.length;
      }
    });

    if (isInsideModal) {
      handleSubmit(e, {
        selectedIds: selected,
        selectedCount: taskId
          ? taskDetail?.totalAssignees + selected?.length
          : selected?.length,
      });
    } else if (selected?.length) {
      if (!addTask) {
        const params = {
          assignees: selected,
          ...(accountOwnerId && { accountOwnerId: accountOwnerId }),
        };
        handleActiontask(assigneeTaskId, "Reassign", params);
      }
      handleToggle();
    }
  };

  const handleFileChange = (event) => {
    if (!event || !event.target) return;
    const files = event.target.files;
    if (!files.length) return;

    let newFiles = [];
    for (let i = 0; i < files.length; i++) {
      if (!allowedTypes.includes(files[i]?.type)) {
        toast.error(t("fileNotSupported"));
        continue;
      }

      if (files[i]?.size > constants.MAX_FILE_SIZE_5_MB) {
        toast.error(`${t("form.errors.fileSize")}`);
        continue;
      }

      newFiles.push({
        path: URL.createObjectURL(files[i]),
        file: files[i],
        Id: 0,
        IsDeleted: false,
      });
    }
    setFileNames((prev) => [...prev, ...newFiles]);
    event.target.value = "";
  };

  const handleCancelCheck = () => {
    handleToggle();
  };

  const handleRemoveFile = (index) => {
    setFileNames((prev) => prev.filter((_, i) => i !== index));
  };

  const navigateToTaskListing = () => {
    const search =
      location.search ||
      (selectedOwnerIdString ? `?${selectedOwnerIdString}` : "");
    history.push({
      pathname: constants.routes.taskManagements.taskManagement,
      search,
    });
  };

  const onBack = () => {
    if (taskId) {
      navigateToTaskListing();
      return;
    }
    if (window.history.length > 1) {
      history.goBack();
    } else if (isChatFromDashBoard) {
      history.push(constants.routes.dashboard.managerDashboard);
    } else {
      navigateToTaskListing();
    }
  };
  useEffect(() => {
    if (
      errors?.title ||
      errors?.description ||
      errors?.startDate ||
      errors?.DueDate ||
      errors?.staffSelection
    ) {
      isValidEvent(isInsideModal);
    }
  }, [formData, dates, selectedStaff]);
  const isValidEvent = (dontCheckStaff) => {
    const errorsData = cloneDeep(errors);
    //Title
    if (!formData.title.trim().length) {
      errorsData.title = t("form.errors.emptyField", {
        field: t("title"),
      });
    } else {
      delete errorsData.title;
    }
    //Description
    if (!formData.description.trim().length) {
      errorsData.description = t("form.errors.emptyField", {
        field: t("description"),
      });
    } else {
      delete errorsData.description;
    }
    //dates
    if (!dates.startDate) {
      errorsData.startDate = t("form.errors.emptyField", {
        field: t("end date"),
      });
    } else {
      delete errorsData.startDate;
    }
    if (!dates.DueDate) {
      errorsData.DueDate = t("form.errors.emptyField", { field: t("dueDate") });
    } else if (
      dates.startDate &&
      moment(dates.DueDate)
        .startOf("day")
        .isBefore(moment(dates.startDate).startOf("day"))
    ) {
      errorsData.DueDate = t("taskManagement.dueDateGreaterThanStartDate");
    } else {
      delete errorsData.DueDate;
    }
    if (
      Object.keys(selectedStaff).filter((key) => selectedStaff[key]).length ||
      dontCheckStaff ||
      taskId
    ) {
      delete errorsData.staffSelection;
    } else if (!dontCheckStaff) {
      errorsData.staffSelection = t("form.errors.emptyField", {
        field: t("taskManagement.assignees"),
      });
    }

    setErrors(errorsData);
    return !Object.values(errorsData).some((err) => !!err);
  };

  const getOfficeMembers = async () => {
    setShowLoader(true);
    try {
      const res = await filterOptionsStaff(accountOwnerId, taskId);

      if (res && res.length) {
        setOptionsStaff(res);
      }
      setShowLoader(false);
    } catch (e) {
      setShowLoader(false);
    }
  };

  const handleSubmit = async (e, paramsSubmit) => {
    e.preventDefault();

    if (isValidEvent()) {
      setShowLoader(true);
      const { startDate: apiStartDate, dueDate: apiDueDate } =
        formatSelectedDatesForApi(dates);
      try {
        let taskDocumentUrls = [];
        for (let i = 0; i < fileNames.length; i++) {
          let fileObj = fileNames[i];
          if (fileObj.file && fileObj.path) {
            const [err, blobData] = await uploadImage(
              fileObj.file,
              containerName,
            );
            if (err) {
              throw new Error(err);
            }
            taskDocumentUrls.push({
              Id: 0,
              FilePath: `${containerName}/${blobData.blobName}`,
              IsDeleted: false,
            });
            fileObj.path = blobData.blobUrl;
            fileObj.file = null;
          } else if (fileObj.path && !fileObj.file) {
            taskDocumentUrls.push({
              Id: fileObj.Id || 0,
              FilePath: fileObj.path,
              IsDeleted: fileObj.IsDeleted || false,
            });
          }
        }
        if (taskId && Array.isArray(taskDetail?.taskDocumentUrls)) {
          taskDetail.taskDocumentUrls.forEach((doc) => {
            if (
              !fileNames.some((f) => f.path === doc.filePath) &&
              (doc.id || doc.filePath)
            ) {
              taskDocumentUrls.push({
                Id: doc.id,
                FilePath: doc.filePath,
                IsDeleted: true,
              });
            }
          });
        }
        const params = {
          title: formData?.title,
          description: formData?.description,
          startDate: apiStartDate,
          dueDate: apiDueDate,
          priority: priority,
          notifyAssignees: formData?.notifyAssignees,
          notifyAssignor: formData?.notifyAssignor,
          assignees: paramsSubmit?.selectedIds ?? confirmedStaff,
          TaskDocumentUrls: taskDocumentUrls,
          accountOwnerId: accountOwnerId || null,
        };
        if (taskId) {
          params.taskId = +taskId;
          let res = await EditTask(params);
          if (res.status) {
            // Invalidate queries to refresh data
            queryClient.invalidateQueries(["tasks/id", taskId]);
            queryClient.invalidateQueries(["tasks/Assignee/id", taskId]);
            queryClient.invalidateQueries(["/tasks/accountowner"]);
            queryClient.invalidateQueries(["tasks"]);
            // Force immediate refetch of all related queries
            queryClient.refetchQueries(["/tasks/accountowner"]);
            queryClient.refetchQueries(["tasks"]);
            toast.success(res.message);
            if (isInsideModal) {
              closeModalHandler();
            } else {
              onBack();
            }
          }
        } else {
          let res = await addNewTask(params);
          if (res.status) {
            // Invalidate queries to refresh data
            queryClient.invalidateQueries(["/tasks/accountowner"]);
            toast.success(res.message);
            if (isInsideModal) {
              closeModalHandler();
            } else {
              onBack();
            }
          }
        }
      } catch (err) {
        toast.error(err.message);
      } finally {
        setShowLoader(false);
      }
    }
  };
  const isAnyLoading = detailsLoading || showLoader;

  return {
    data: {
      isAnyLoading,
      dates,
      formData,
      priority,
      prioritiesOptions,
      errors,
      isModalOpen,
      OptionsStaff,
      fileNames,
      staffSelectedCount,
      selectedOption,
      selectedStaff,
      taskId,
      taskDetail,
    },
    methods: {
      setFormData,
      handleOnChange,
      setPriority,
      updateDatesValues,
      handleSubmit,
      handleToggle,
      handleCheckboxChange,
      handleApplyCheck,
      handleFileChange,
      handleRemoveFile,
      handleCancelCheck,
      onBack,
      setSelectedOption,
      setFileNames,
      setSelectedStaff,
      isValidEvent,
    },
  };
};
